import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-20 h-20 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-3xl font-semibold mb-6">
        叶
      </span>
      <p className="font-heading text-6xl md:text-8xl font-semibold text-primary-200 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
        页面未找到
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all max-w-md">
        {location.pathname}
      </p>
      <p className="mt-3 text-sm text-foreground-500 max-w-md">
        你访问的页面可能已被移除或链接有误，可以返回首页继续浏览作品与资讯。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-4-line"></i>
          </span>
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-film-line"></i>
          </span>
          浏览作品
        </Link>
      </div>
    </div>
  );
}